import { render, staticRenderFns } from "./ResetUser.vue?vue&type=template&id=60d2c2ce"
import script from "./ResetUser.vue?vue&type=script&lang=js"
export * from "./ResetUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports